module.exports = __webpack_public_path__ + "img/stop.7ed9c360.png";